import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class AdminsProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(): Promise<AdminSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/admins';
        return await this.http.get<AdminSummaryDTO[]>(url).toPromise();
    }

    async create(createAdminDTO: CreateAdminDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/admins';
        return await this.http.post(url, createAdminDTO).toPromise();
    }

    async delete(email: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/admins';
        let params = new HttpParams().set('email', email);
        return await this.http.delete(url, { params: params }).toPromise();
    }

    async resetPassword(email: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/admins/resetPassword';
        let params = new HttpParams().set('email', email);
        return await this.http.post(url, {}, { params: params }).toPromise();
    }
}

export interface AdminSummaryDTO {
    firstName: string;
    lastName: string;
    email: string;
    lastLogin: Date | string | null;
    permissions: string[];
    canBeDeleted: boolean;
}

export interface CreateAdminDTO {
    firstName: string;
    lastName: string;
    email: string;
}
